import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export type UnsubscribeOptions = {
  requestMethod: RequestMethodsEnum
  getRequestUrl: (time: 'now' | 'when_ends') => string
  getRequestBody?: (time: 'now' | 'when_ends') => unknown
}

export const useUnsubscribe = ({
  requestMethod,
  getRequestUrl,
  getRequestBody,
}: UnsubscribeOptions) => {
  const { fetcher: fetcherNow, isFetching: isFetchingNow } = useFetch({
    method: requestMethod,
  })

  const { fetcher: fetcherWhenEnds, isFetching: isFetchingWhenEnds } = useFetch({
    method: requestMethod,
  })

  return {
    unsubscribe: async ({ time }: { time: 'now' | 'when_ends' }) => {
      await (time === 'now' ? fetcherNow : fetcherWhenEnds)(
        getRequestUrl(time),
        getRequestBody?.(time),
      )
    },
    isFetchingNow,
    isFetchingWhenEnds,
  }
}
